<template>
  <div class="csb">
    <span class="csb__n">{{ count }} of {{ total }} {{ noun }}</span>
    <span class="csb__sp"></span>
    <button type="button" class="csb__a" :disabled="count >= total" @click="$emit('all')">Select all</button>
    <button type="button" class="csb__a" :disabled="count === 0" @click="$emit('none')">Select none</button>
  </div>
</template>

<script>
/**
 * #2091 — Select all / Select none, as Ed asked for on every name list.
 *
 * One component rather than four copies, so the lists cannot drift apart: the
 * search results, the people named individually, the role switches, the channel
 * groups and the global grants all use this.
 *
 * It owns no state. The parent passes the current count and total and handles
 * the two events, which is what lets the grants list exclude Members from both
 * the count and "Select all" — they can never be granted, and a control that
 * silently granted them would contradict the rule printed beside it.
 */
export default {
    name: 'chatSelectBar',
    props: {
        count: { type: Number, required: true },
        total: { type: Number, required: true },
        noun: { type: String, default: 'selected' },
    },
};
</script>

<style scoped>
.csb{
    display:flex;align-items:center;gap:8px;
    margin:13px 0 2px;padding:5px 0;
    border-top:1px solid #e8ebf0;border-bottom:1px solid #e8ebf0;
}
.csb__n{
    font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:10px;
    color:#8b949e;letter-spacing:.02em;
}
.csb__sp{flex:1}
.csb__a{
    background:none;border:0;padding:3px 2px;
    font-size:11.5px;font-weight:600;color:#2451a8;cursor:pointer;
}
.csb__a:hover{text-decoration:underline}
.csb__a:disabled{color:#8b949e;cursor:default;text-decoration:none}
</style>
